<template>
	<div class="popup popup--middle" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Как добраться</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__img">
					<img :src="img" alt="" loading="lazy"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ContactsRoutePopup",
	props: {
		img: {
			type: String,
			default: () => ''
		}
	},
}
</script>


